import { FC, ReactNode } from 'react';
import Navbar from './navbar/Navbar';
import Footer from './footer/Footer';
import useJurisdiction from '../../hooks/useJurisdiction';

type Props = {
    children: ReactNode,
};

const Layout: FC<Props> = ({ children }) => {
    const { isRequestHideHeadNav } = useJurisdiction();
    
    return (
        <div className="bg-gray-100 font-sans leading-normal tracking-normal min-h-screen">
            <div className="bg-gray-100 font-sans leading-normal tracking-normal">
                <div className="flex flex-col min-h-screen">
                    {!isRequestHideHeadNav && (
                        <Navbar />
                    )}
    
                    <div className="flex-grow">
                        <div className="container mx-auto">
                            {children}
                        </div>
                    </div>
    
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default Layout;